import { render, staticRenderFns } from "./productlinefiletable.vue?vue&type=template&id=ca523ae0&scoped=true&"
import script from "./productlinefiletable.vue?vue&type=script&lang=js&"
export * from "./productlinefiletable.vue?vue&type=script&lang=js&"
import style0 from "./productlinefiletable.vue?vue&type=style&index=0&id=ca523ae0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca523ae0",
  null
  
)

export default component.exports